var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSerial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62498 6.25H4.37498V10H5.62498V6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.25H11.875V10H13.125V6.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12498 5H6.87498V13.125H8.12498V5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 3.75H9.37498V11.875H10.625V3.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C13.1903 2.5 13.75 1.94036 13.75 1.25C13.75 0.559644 13.1903 0 12.5 0C11.8096 0 11.25 0.559644 11.25 1.25C11.25 1.94036 11.8096 2.5 12.5 2.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 16.25C5.69034 16.25 6.24998 15.6904 6.24998 15C6.24998 14.3096 5.69034 13.75 4.99998 13.75C4.30963 13.75 3.74998 14.3096 3.74998 15C3.74998 15.6904 4.30963 16.25 4.99998 16.25Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5572 15.625H7.49998V14.375H12.5572L16.2499 8.125L14.5629 5.27006L15.6395 4.63406L17.3265 7.489C17.5579 7.88112 17.5579 8.36881 17.3265 8.761L13.6333 15.011C13.4099 15.3894 12.9973 15.625 12.5572 15.625Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86048 11.6162L0.173484 8.76094C-0.0578281 8.36881 -0.0578281 7.88112 0.173484 7.48894L3.86673 1.23894C4.09073 0.860187 4.50273 0.624938 4.9428 0.624938H10V1.87494H4.9428L1.25017 8.12494L2.93717 10.9802L1.86048 11.6162Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSerial);
export default __webpack_public_path__ + "static/media/ic-serial.2e2630a0bbde9ef1c3ae4959bc39089b.svg";
export { ForwardRef as ReactComponent };